import http from "services/http/httpInstance";
import { authHeader } from "services/http/AuthService";

const url = "/orders/";

export const httpGetOrders = (request) =>
  http({
    url: url,
    method: "GET",
    headers: {
      ...authHeader(),
    },
    ...request,
  });

/** Unified completed orders + preorders (dashboard list). */
export const httpGetCompletedTrips = (request) =>
  http({
    url: url + "completed_trips/",
    method: "GET",
    headers: {
      ...authHeader(),
    },
    ...request,
  });

export const httpGetOrder = (request, orderId) =>
  http({
    url: url + orderId + "/",
    method: "GET",
    headers: {
      ...authHeader(),
    },
    ...request,
  });

export const httpGetReceipt = (orderId) =>
  http({
    url: url + orderId + "/get_driver_receipt/?download=1",
    method: "GET",
    responseType: "blob",
    headers: {
      ...authHeader(),
      "content-type": "octet/stream",
    },
  });

export const httpGetOrdersAnalytics = () =>
  http({
    url: url + "analytics/",
    method: "GET",
    headers: {
      ...authHeader(),
    },
  });
